import { Restaurant } from '@/typings/entity/restaurant';
import makeAxiosClient from '@/helpers/axios';
import { FetchRestaurantRequestParameters } from '@/typings/http/restaurant';

export async function fetchRestaurant(params: FetchRestaurantRequestParameters) {
  return makeAxiosClient()
    .get<Restaurant>(`/restaurant/${params.restaurantId}`)
    .then((res) => res.data);
}
